/* External Imports */

import { Box, Center, Hide, Show, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import StructuredTextParser from '@app-ps/Utility/StructuredTextParser';
import config from '@config';
import { render } from 'datocms-structured-text-to-html-string';

/**
 *
 * @param {Object} sectionContent
 * @param {Object} region - Data from api
 * @param {Object} lang - Data from api
 * @returns
 */
const PsIntroSection = ({ sectionContent, section }) => {
  // const isDesk = useMediaQuery({ maxWidth: 1200 });
  const imageUrl = sectionContent.find(item => item.fieldId === 'left-image')
    ?.image?.url;
  const kolamImageUrl = sectionContent.find(
    item => item.fieldId === 'kolam-right'
  )?.image?.url;
  const experienceText = sectionContent.find(
    item => item.fieldId === 'text-1'
  )?.text;
  const classicalArtsText = sectionContent.find(
    item => item.fieldId === 'text-2'
  )?.text;
  const transformationText = sectionContent.find(
    item => item.fieldId === 'text-3'
  )?.text;
  const BgName = section?.styleConfig?.administrativeName;
  const bgImages = {
    'brown-bg': `${config.imgPath}/d/46272/1722883168-group-1316.png`,
    'soil-bg': `${config.imgPath}/d/46272/1721975082-group-1171277741.png`,
  };
  // console.log(section?.styleConfig?.administrativeName, bgImages[section?.styleConfig?.administrativeName], "psintro")

  return (
    <Box
      width="100%"
      overflowX={'hidden'}
      bgImage={bgImages[section?.styleConfig?.administrativeName]}
      backgroundBlendMode="multiply"
      pt={
        BgName === 'brown-bg'
          ? { lg: '0', xl: '10rem' }
          : { lg: '5rem', xl: '10rem' }
      }
      mt={
        BgName === 'brown-bg'
          ? { base: '5rem', lg: '0', xl: '0' }
          : { base: '5rem', lg: '0', xl: '0' }
      }
      // pb={{ base: '8rem', lg: '22rem' }}
      pb={
        BgName === 'brown-bg'
          ? {
              base: '40rem',
              sm: '25rem',
              lg: '26rem',
              xl: '28rem',
              '2xl': '30rem',
            }
          : { base: '13rem', lg: '12rem', xl: '22rem' }
      }
      pl={{ xl: '5rem' }}
      pr={{ xl: '0rem' }}
      bgRepeat="no-repeat"
      backgroundSize="100% 100%"
      css={{ backgroundBlendMode: 'multiply' }}
      backgroundPosition="top"
    >
      <Show breakpoint="(min-width: 1200px)">
        <Box
          p={{
            base: '4rem 0 10rem 0',
            md: '4rem 10rem 4rem',
            xl: '5rem 8rem 7rem',
            '2xl': '5rem 8rem 5rem',
          }}
          width={{ base: '100%', lg: '90%' }}
          mx="auto"
          maxW={{ base: 1170, '2xl': 1400 }}
          // bgImage={{
          //   base: 'linear-gradient(180deg, #fefaf6, #fefaf6 0.01%, rgba(254, 250, 246, 0.79) 60%, rgba(254, 250, 246, 0.67) 74.5%, rgba(254, 250, 246, 0))',
          //   lg: 'linear-gradient(270deg, #fefaf6, #fefaf6 0.01%, rgba(254, 250, 246, 0.79) 60%, rgba(254, 250, 246, 0.67) 74.5%, rgba(254, 250, 246, 0))',
          // }}
          _before={{
            content: "''",
            right: '0',
            width: { base: '90%', '2xl': '85%' },
            pos: 'absolute',
            top: '0',
            zIndex: 0,
            bottom: '0',
            bgImage: {
              base: 'linear-gradient(180deg, #fefaf6, #fefaf6 0.01%, rgba(254, 250, 246, 0.79) 60%, rgba(254, 250, 246, 0.67) 74.5%, rgba(254, 250, 246, 0))',
              lg: 'linear-gradient(270deg, #fefaf6, #fefaf6 0.01%, rgba(254, 250, 246, 0.79) 60%, rgba(254, 250, 246, 0.67) 74.5%, rgba(254, 250, 246, 0))',
            },
          }}
          position="relative"
        >
          <Box
            display={{ base: 'none', lg: 'block' }}
            position="absolute"
            right="8"
            top="0rem"
            bottom="37rem"
            zIndex="990"
          >
            {kolamImageUrl && (
              <LazyLoadImageComponent
                src={kolamImageUrl}
                alt="Kolam performances"
                width="120px"
              />
            )}
          </Box>
          {/* wrapper for all text */}
          <Box
            // border={'2px solid yellow'}
            width={{
              lg: '70%',
              '2xl': BgName === 'brown-bg' ? '85%' : '70%',
            }}
            pos="relative"
            zIndex="2"
            marginLeft={{
              lg: 'auto',
              xl: '25%',
              '2xl': BgName === 'brown-bg' ? '25%' : 'auto',
            }}

            // mt={{ base: '8rem' }}
          >
            <Box
              mx={{ base: '1rem', xl: '0' }}
              mt={{ base: '3rem', md: '0' }}
              color="#010509"
            >
              <Text
                fontSize={{ base: '44px', lg: '3.125rem', '2xl': '3.75rem' }}
                lineHeight="120%"
                letterSpacing="1%"
                fontWeight="normal"
                fontFamily="var(--FedraSerifDisplay-Regular)"
                color="#010509"
              >
                {experienceText}
              </Text>
              <Text
                fontFamily="var(--FedraSerifDisplay-Bold)"
                // fontWeight="700"
                letterSpacing="1%"
                lineHeight="120%"
                color="#010509"
                fontSize={{ base: '1.5rem', md: '2.5rem', '2xl': '2.75rem' }}
              >
                {classicalArtsText}
              </Text>
              <Text
                fontSize={{ base: '1.3rem', md: '2rem', '2xl': '2.25rem' }}
                fontFamily="var(--FedraSerifDisplay-Regular)"
                fontWeight="400"
                color="#010509"
                letterSpacing="0.36px"
              >
                {transformationText}
              </Text>
            </Box>

            <Box
              width={{ md: '100%' }}
              px={{ base: '1rem', xl: '0' }}
              fontSize={{ base: '0.875rem', md: '1.125rem' }}
              fontFamily="var(--FedraSansStd-book)"
              mt={{ base: '2rem' }}
              letterSpacing="2%"
              fontWeight="thin"
            >
              <StructuredTextParser
                mb={{ base: '1.5rem' }}
                p="0"
                fontSize={{ base: '0.875rem', md: '1.125rem' }}
                fontFamily="var(--FedraSansStd-book)"
                mt={{ base: '2rem' }}
                letterSpacing="0.36px"
                maxW={{
                  base: '660px',
                  '2xl': BgName === 'brown-bg' ? '846px' : '660px',
                }}
                mx="0"
                fontWeight="thin"
                lineHeight={{ base: '22.4px', lg: '28.8px' }}
                color="#010509"
                str={render(sectionContent[4]?.body)}
              />
            </Box>
          </Box>
          <Box
            pos={{ base: 'static', xl: 'absolute' }}
            left={{ lg: '-5%', xl: '-12%', '2xl': '0%' }}
            top={{
              base: '-20px',
              // xl: '-10%',
              xl: BgName === 'brown-bg' ? '-1%' : '-10%',

              '2xl': BgName === 'brown-bg' ? '5px' : '-20px',
            }}
            bottom="-40px"
            width={{ xl: '473px', '2xl': 'auto' }}
            // h={{ xl: '741px', '2xl': 'auto' }}
            h={{
              xl: BgName === 'brown-bg' ? '700px' : '741px',

              '2xl': 'auto',
            }}
            display={{ base: 'flex', xl: 'block' }}
            alignItems="center"
            justifyContent="center"
            // top={{ lg: '-3rem' }}
          >
            {imageUrl && (
              <LazyLoadImageComponent
                src={imageUrl}
                alt="Dance performance"
                maxH={{ base: '360px', lg: '100%' }}
                // width="auto"
                width={{ base: 'auto', xl: '100%', '2xl': 'auto' }}
                h={{ base: 'auto', lg: '100%' }}
                objectFit="fill"
                objectPosition="center"
                verticalAlign="middle"
              />
            )}
          </Box>
        </Box>
      </Show>

      <Hide breakpoint="(min-width: 1200px)">
        <Box
          // overflowY="hidden"
          p={{
            base: '2rem 0 13rem 0',
            md: '4rem 2rem 15rem',
            lg: '4rem 2rem 14rem',
            xl: '4rem 10rem 12rem',
          }}
          // mb={
          //   BgName === 'brown-bg'
          //     ? { base: '22%', lg: '0rem' }
          //     : { base: '14%', lg: '0rem' }
          // }
          width="100%"
          mx="auto"
          maxW={{ base: 1170, '2xl': 1400 }}
          bg={{
            base: 'linear-gradient(179deg, #fefaf6, #fefaf6 0.01%, rgba(254, 250, 246, 0.79) 60%, rgba(254, 250, 246, 0.67) 74.5%, rgba(254, 250, 246, 0))',
            xl: 'linear-gradient(270deg, #fefaf6, #fefaf6 0.01%, rgba(254, 250, 246, 0.79) 60%, rgba(254, 250, 246, 0.67) 74.5%, rgba(254, 250, 246, 0))',
          }}
          position="relative"
        >
          {/* wrapper for all text */}
          <Box
            // border={'2px solid yellow'}
            width="100%"
            marginLeft={{ lg: 'auto' }}
            // mt={{ base: '8rem' }}
          >
            <Box px="1rem" mt={{ base: '3rem', md: '0' }} color="#010509">
              <Text
                fontSize={{ base: '44px', lg: '3.75rem' }}
                lineHeight={{ base: '52.8px', lg: '72px' }}
                letterSpacing="1%"
                fontWeight="normal"
                fontFamily="var(--FedraSerifDisplay-Regular)"
                color="#010509"
              >
                {experienceText}
              </Text>
              <Text
                fontFamily="var(--FedraSerifDisplay-Bold)"
                // fontWeight="700"
                letterSpacing="1%"
                lineHeight={{ base: '28.8px', lg: '52.8px' }}
                color="#010509"
                fontSize={{ base: '1.5rem', md: '2rem', lg: '2.75rem' }}
              >
                {classicalArtsText}
              </Text>
              <Text
                fontSize={{ base: '20px', md: '2rem', lg: '2.25rem' }}
                fontFamily="var(--FedraSerifDisplay-Regular)"
                fontWeight="400"
                color="#010509"
                lineHeight={{ base: '24px', lg: '43.2px' }}
                letterSpacing="0.36px"
              >
                {transformationText}
              </Text>
            </Box>

            <Box
              px="1rem"
              fontSize={{ base: '0.875rem', md: '1.125rem' }}
              // width={{ md: '100%' }}
              // mx={{ base: '1rem', xl: '0' }}
              fontFamily="var(--FedraSansStd-book)"
              mt={{ base: '2rem' }}
              letterSpacing="2%"
              fontWeight="thin"
              lineHeight="160%"
            >
              <StructuredTextParser
                mb={{ base: '1.5rem' }}
                p="0"
                paddingRight={{ base: '1rem', md: '0' }}
                color="#010509"
                str={render(sectionContent[4]?.body)}
              />
            </Box>
          </Box>
        </Box>
        <Box
          // bottom={{ base: '-30%', md: '-45%' }}
          // left={{ base: '0' }}
          // right="0"
          display={{ base: 'flex', xl: 'block' }}
          alignItems="center"
          flexDir="column"
          mt={{ base: '-36%', sm: '-20%', md: '-30%', lg: '-20%', xl: '-50%' }}
          justifyContent="center"
          px="16px"
          pos="relative"
          zIndex="10"
          // top={{ lg: '-3rem' }}
        >
          <Center>
            {imageUrl && (
              <LazyLoadImageComponent
                src={imageUrl}
                maxH={{ base: '365px', md: '450px', xl: '470px' }}
                alt="Dance performance"
                // maxH={{ base: '360px', md: '560px' }}
                width="auto"
                height="auto"
                objectFit="fill"
                objectPosition="center"
                verticalAlign="middle"
              />
            )}
          </Center>
          {BgName === 'brown-bg' && (
            <Box
              color="#D45F02"
              pos="relative"
              top="5rem"
              mx="auto"
              maxW="500px"
            >
              <LazyLoadImageComponent
                src="https://static.sadhguru.org/d/46272/1729178523-brownkolam.png"
                alt="Workshop Kolam"
                layout="responsive"
              />
            </Box>
          )}
        </Box>
      </Hide>
      {/* kolam */}
    </Box>
  );
};

export default PsIntroSection;
